import React from "react";
import { Button, ArrowLeftIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedButtonWithStartIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Outlined button with start icon"}
        value={
          '<Button variant={"outlined"} startIcon={<ArrowLeftIcon />}>Back</Button>'
        }
      >
        <Button variant={"outlined"} startIcon={<ArrowLeftIcon />}>
          Back
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedButtonWithStartIcon;
